// Copyright 2025, University of Maryland, All Rights Reserved
import type { NodeApiClient } from '@/app-shell/services'
import type { UILayout } from '../types'

/**
 * Layout API service for persisting workspace UI layouts.
 */
export class LayoutService {
  constructor(private readonly client: NodeApiClient) {}

  async saveLayout(orgId: string, workspaceId: string, layout: UILayout): Promise<UILayout> {
    const { data } = await this.client.put<UILayout>(
      `/workspaces/${orgId}/${workspaceId}/ui-layout`,
      layout,
    )
    return data
  }
}
